import React, { useState, useEffect } from 'react';

export default function AcoesAnexos({ requerimento }) {
    //Estado de controle de exibição dos valores dos cards
    const [showContent, setShowContent] = useState({});

    useEffect(() => {
        const _showContent = {};
        requerimento.requerimentoAcos.map((value, index) => {
            if (index == 0) {
                _showContent[index] = true;
            } 
        })
        setShowContent(_showContent);
    }, []);

    return (
        <>
            {requerimento?.requerimentoAcos?.length > 0 && requerimento.requerimentoAcos.map((value, index) => (

                <div className='print-acoes px-2 contentGroup' style={{ position: "relative" }} key={index}>
                    <div className='row shadowFicha rounded-1 mt-2 mb-4'>
                        <div className={`cardContainer ${showContent[index] ? "" : "close"}`}>
                            {
                                value.formularios && value.formularios.length > 0 &&
                                value.formularios.map((formulario, index) => {
                                    return (
                                        console.log(value),
                                        <div className='row' key={index}>
                                            <p>
                                                <span className="fw-bold">{value?.formularios[index]?.nomeFormulario}</span>
                                                <div>
                                                    <img className='rounded-3' src={value?.formularios[index]?.requerimentoEspecie?.imagem} width={200} />
                                                    <p><b>Espécie: </b><span>{value?.formularios[index]?.requerimentoEspecie?.especie}</span></p>
                                                </div>
                                            </p>
                                            {
                                                formulario.requerimentoAcaoFormularioResposta.map((resposta, index) => {
                                                    if (resposta.imagem != null) {
                                                        return (
                                                            <div className='col-md-12 col-lg-12' key={index}>
                                                                <p>
                                                                    <div>
                                                                        <img className='rounded-3' src={resposta.imagem} width={200} />
                                                                        <p><span className="fw-bold">{resposta.questao}</span> {resposta.valor}</p>
                                                                    </div>
                                                                </p>
                                                                <p>
                                                                </p>
                                                            </div>
                                                        )
                                                    }
                                                })
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>

                    </div>
                </div>
            ))
            }
        </>
    )
}